import React from 'react';
import { Trans } from 'react-i18next';

import { Link } from 'src/shared/components';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import { Route } from 'src/shared/route';

import type { ErrorSplashProps } from './ErrorSplash';
import { ErrorSplash } from './ErrorSplash';

export interface NotFoundSplashProps extends Partial<ErrorSplashProps> {}

const NotFoundSplash = (props: NotFoundSplashProps) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  return (
    <ErrorSplash
      callToAction={
        <Trans
          components={{ HomeLink: <Link to={Route.HOMEOWNER_APP_HOME.path} /> }}
          i18nKey="notFound.callToAction"
          t={t}
        />
      }
      heading={t('notFound.404')}
      subtitle={t('notFound.pageNotFound')}
      {...props}
    />
  );
};

export { NotFoundSplash };
